import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import FileHandlerService from "./fileHandler.service";
import { HttpService } from "./http.service";

const basePath = "/EquipmentExport";
import { t } from 'i18next';

export const EventExportService = {
  Export,
  ExportInconsistentForecast,
  ExportEquipmentForcedWithoutCollection,
  ExportEquipmentBalanceLimitExceeded,
  ExportCollectionScheduleForecast,
  ExportEquipmentImposedWithoutCollection,
  ExportPickupUpEquipmentForecast
};

async function Export(data: RequestInputOutputParamsModel) {


  let url = `${basePath}/Export`;

  return FileHandlerService.DownloadFile(basePath, url, data, "Excel");
}

async function ExportInconsistentForecast(data: RequestInputOutputParamsModel) {
  let url = `${basePath}/ExportInconsistentForecast`;

  return FileHandlerService.DownloadFile(basePath, url, data, "Excel");
}

async function ExportCollectionScheduleForecast(data: RequestInputOutputParamsModel) {
  let url = `${basePath}/ExportCollectionScheduleForecast`;

  return FileHandlerService.DownloadFile("PROG_SCHEDULE", url, data, "Excel");
}

//sprint 27  - 10238 - Relatório Indicador - Coleta imposta sem programação da Filial - Fase 1
async function ExportEquipmentForcedWithoutCollection(data: RequestInputOutputParamsModel,type: string) {
  let url = `${basePath}/ExportEquipmentForcedCollection`;
  if (type == "Csv") type = "zip";
  return FileHandlerService.DownloadFile("IMPOSITIONEXPORT", url, data, type);
}
//sprint 27  - 10238 - Relatório Indicador - Coleta imposta sem programação da Filial - Fase 1

//sprint 28  - 10714 - Equipamentos com limite excedido de saldo online sem programação da Filial - Fase 1
async function ExportEquipmentBalanceLimitExceeded(data: RequestInputOutputParamsModel,type: string) {
  let url = `${basePath}/ExportEquipmentBalanceLimitExceeded`;
  if (type == "Csv") type = "zip";
  return FileHandlerService.DownloadFile("BALANCELIMITEXCEEDED", url, data, type);
}
//sprint 28  - 10714 - Equipamentos com limite excedido de saldo online sem programação da Filial - Fase 1


async function ExportEquipmentImposedWithoutCollection(data: RequestInputOutputParamsModel,type: string) {
  let url = `${basePath}/ExportEquipmentImposedPickupModal`;
  if (type == "Csv") type = "zip";
  return FileHandlerService.DownloadFile("IMPOSITIONEXPORT", url, data, type);
}


async function ExportPickupUpEquipmentForecast(data: RequestInputOutputParamsModel,type: string) {
  let url = `${basePath}/ExportPickupUpEquipmentForecast`;
  if (type == "Csv") type = "zip";
  return FileHandlerService.DownloadFile("PICKEDUP_EQUIPMENT", url, data, "Excel");
}

export default EventExportService;
